import { ErrorBoundary, FallbackProps } from 'react-error-boundary'
import { QueryErrorResetBoundary } from 'react-query'

/** Compose an error boundary for react-query. */
export const QueryErrorBoundary = ({
  children,
  FallbackComponent,
}: {
  children: React.ReactNode
  FallbackComponent: React.ComponentType<FallbackProps>
}) => (
  <QueryErrorResetBoundary>
    {({ reset }) => (
      <ErrorBoundary onReset={reset} FallbackComponent={FallbackComponent}>
        {children}
      </ErrorBoundary>
    )}
  </QueryErrorResetBoundary>
)
